'use strict';

import axios from 'axios';
import getHeader from '../config/header';
import Format from '../services/formats';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Notifications = {

    async sendForEvent(eventID, title, message) {
      try {

        if (!eventID || !title || !message) {
            return { error: "A mandatory field is missing" };
        }

        const headers = await getHeader();

        let response = await axios.post(API_URL + '/event/notification/' + eventID, {
            "title": title,
            "message": message
        }, headers);
        
        return true;

      } catch(error) {
        if (error.response.data.Error) {
            return { "error": error.response.data.Error };
        }

        return false;
      }
    }    
    
}

export default Notifications;